/// <amd-module name="typeahead/core/SuggestionModifier" />

import {ConfigurableFeature} from "ConfigurableFeature";
import {IOverrideParams} from "typeahead/core/IOverrideParams";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";

export abstract class SuggestionModifier extends ConfigurableFeature {
    protected modifySuggestions(suggestions: Object[], context: IContext, options: IOverrideParams): Object[] {
        if (this.precondition(suggestions, context) &&
                    (this.shouldOverride(options) || ExecutionHelper.shouldExecute(context, this.configuration))) {
            this.modify(suggestions, context);
        }
        return suggestions;
    }
    protected precondition(suggestions: any, context: IContext) {
        return suggestions && suggestions.length > 0;
    }
    protected abstract modify(suggestions: any, context: IContext);
}
